import { ToothSvgComponentProps } from '@/modules/patientList/patientStrip/patientStripOdontogram/types';

const SvgNormal = (props: ToothSvgComponentProps) => (
  <svg
    width={9 * (props.wx ?? 1)}
    height={26 * (props.hx ?? 1)}
    viewBox="0 0 9 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={props.className}
  >
    <path
      d="M7.52948 7.53849C7.48432 7.83258 7.40876 8.44414 7.1403 9.00594C6.87817 9.55401 6.62491 10.1073 6.53374 10.6966C6.03987 13.8787 6.14286 17.355 5.10152 21.1636C4.40884 23.6975 4.36451 25.2314 3.87698 25.3202C3.33583 25.4186 2.60306 23.8754 2.54903 21.063C2.47389 17.127 1.66936 13.233 1.47899 10.792C1.3895 9.64164 1.0535 9.02339 0.956834 8.71928C0.874101 8.45862 0.818379 8.16008 0.784188 7.82032C0.668953 6.68186 0.69471 4.36781 0.793061 2.77634C0.850468 1.84471 0.987647 1.46337 1.73605 1.40247C3.3485 1.27139 5.65575 1.31075 7.10189 1.48305C7.6232 1.54506 7.66879 1.88147 7.68314 2.49674C7.71733 3.99575 7.75109 6.09815 7.52948 7.53849Z"
      fill={props.fill || '#E4E4E7'}
      stroke={props.stroke || '#A1A1AA'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgNormal;
